// ©2024 Austin App House. All rights reserved.
/* eslint-disable jsx-a11y/tabindex-no-positive */

import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from '../../../components/layout/CustomSelect';
import { dashboard as dashboardSelectStyle, dashboardSelectClassNames } from '../../../utils/customSelectStyle';
import Editor from '../../layout/editor';
import axios from 'axios';
import {
  updateProfile,
  getProfile,
  getAccountBalanceByClient,
  deactivateUser,
  activateUser,
  getContractorTaxInfo,
} from '../../../storage/actions/profile';
import ContractorToolsBox from './contractor/ContractorToolsBox';
import { toggleModal } from '../../../storage/actions/modalsActions';
import DashboardModalLoader from '../../dashboard/common/DashboardModalLoader';
import Loader from '../../dashboard/common/Loader';
import ContractorCertificatesChecks from '../../layout/ContractorCertificatesChecks';
import Notification from '../../notification';
import ExplanationDeactivationModal from '../ExplanationDeactivationModal';
import { normalizePhoneInput } from '../../../utils/validators';
import handlerValidateZipCode from '../../../utils/addressSection/handlerValidateZipCode';
import normalizeZipcodeInput from '../../../utils/addressSection/normalizeZipcodeInput';
import ButtonControl from './contractor/ButtonControl';
import { localCurrencySettings } from '../../../utils/constans';
import FileUpload from "../../forms/file-upload/FileUpload";
import FileListPreview from "../../forms/file-upload/FileListPreview";
import NotesSection from '../contractorDetailsModal/NotesSection';
// import '../../../sass/custom_styles/wo_details.css'
import { FaTag, FaEdit, FaPlay } from "react-icons/fa6";
import ContractorToolsWorkTypesDisplay from "./contractor/ContractorToolsWorkTypesDisplay";
import ProfilePasswordField from './ProfilePasswordField';


const Profile = ({
  profile,
  modalStatus,
  auth,
  updateProfile,
  toggleModal,
  getProfile,
  getAccountBalanceByClient,
  deactivateUser,
  activateUser,
}) => {
  const [isEdit, changeEditStatus] = useState(false);
  const [files, setFiles] = useState(profile.cards || [])
  const [countries, setCountries] = useState([]);
  const [statesOfCountry, setStatesOfCountry] = useState([]);
  const [form, setForm] = useState({});
  const [file, setFile] = useState(null);
  const [isDeactivateModal, setDeactivateModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (isEdit) {
      // Ensure the modal's internal scroll container goes to top after edit mode mounts
      requestAnimationFrame(() => {
        if (contentRef.current && typeof contentRef.current.scrollTo === 'function') {
          contentRef.current.scrollTo({ top: 0, behavior: 'auto' });
        } else {
          window.scrollTo(0, 0);
        }
      });
    }
  }, [isEdit]);

  const getStatesOfCountry = async (country) => {
    if (!country) return;
    try {
      if (!country.value) {
        const countryName = country.label || 'United States';
        const value = countries.filter((item) => item.label === countryName)[0];
        // eslint-disable-next-line consistent-return
        return handlerChanges({
          name: 'country',
          value,
        });
      }
      const res = await axios.get('/api/address/getStatesOfCountry', {
        params: { countryId: country?.value || '' },
      });
      setStatesOfCountry(res.data?.payload?.states || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handlerChanges = ({ name, value }) => {
    const newForm = {
      ...form,
      [name]: value,
    };
    if (name === 'country') {
      if (!form.country || form.country.label !== value.label) {
        newForm.state = {};
      }
      getStatesOfCountry(value);
    }

    if (newForm[name] !== form[name]) {
      setForm(newForm);
    }
  };

  useEffect(() => {
    if (auth.isAuthenticated) {
      if (profile === null) getProfile(auth.user.id);
      if (profile.status === 'active') {
        if (auth.user.userType === 'client') {
          getAccountBalanceByClient();
        }
      }
    }
  }, [auth]);

  useEffect(() => {
    getStatesOfCountry(form.country);
  }, [countries]);

  const validateForm = (form) => {
    let formState = { isValid: true, message: '' };
    console.log(form)
    if (!validateEmail(form.email)) {
      formState = false;
      formState.message = 'Please enter valid email address.';
    }

    const zipError = handlerValidateZipCode(form.zipcode, form.country);
    if (zipError) {
      formState.isValid = false;
      formState.message = zipError;
    }


    return formState;
  }


  const validateEmail = (email) => {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email)
      .toLowerCase());
  };

  const handlerSubmit = async (event) => {
    event.preventDefault();
    const formState = validateForm(form);
    console.log(formState);
    if (formState.isValid) {
      const fd = new FormData();
      if (auth.user.userType === 'contractor') {
        fd.append('credentials', form.credentials || '');
        fd.append('other_tools', form.other_tools || '');
        fd.append('tools', form.tools ? JSON.stringify(form.tools) : '');
        fd.append('payPalEmail', form.payPalEmail || '');

        const saved = [], uploaded = [];
        for (const file of files) {
          if (typeof file === "string") saved.push(file);
          else uploaded.push(file)
        }
        uploaded.forEach(file => fd.append('files[]', file, file.name));
        saved.forEach(saved => fd.append('saved[]', saved))
      } else {
        fd.append('companyName', form.company);
        fd.append('companyId', profile.company._id);
      }
      fd.append('firstName', form.firstName);
      fd.append('lastName', form.lastName);
      fd.append('phone', form.phone);
      fd.append('email', form.email);
      fd.append('website', form.website || '');
      fd.append('address', form.address || '');
      fd.append('address2', form.address2 || '');
      fd.append('country', form.country?.label ? JSON.stringify(form.country) : '');
      fd.append('state', form.state?.label ? JSON.stringify(form.state) : '');
      fd.append('about', form.about || '');
      fd.append('city', form.city?.label ? JSON.stringify(form.city) : '');
      fd.append('zipcode', form.zipcode || '');
      fd.append('oldPassword', form.oldPassword || '');
      fd.append('password', form.password || '');
      fd.append('confirmPassword', form.confirmPassword || '');

      if (typeof form.image !== "string") {
        fd.append('file', file);
      }
      const res = await updateProfile(fd, auth.user);
      if (res.success) {
        if (auth.user.userType === 'client') {
          getAccountBalanceByClient();
        }
        return changeEditStatus(false);
      }
      return res;
    }
    return Notification('warning', {
      message: formState.message,
    });
  };

  const saveChangedFiles = async (files) => {
    const fd = new FormData();

    const saved = [], uploaded = [];
    for (const file of files) {
      if (typeof file === "string") saved.push(file);
      else uploaded.push(file)
    }
    uploaded.forEach(file => fd.append('files[]', file, file.name));
    saved.forEach(saved => fd.append('saved[]', saved))

    await updateProfile(fd, auth.user, true);
  }

  const handleFileUpload = (event) => {
    const file = event.target.files;
    const reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onloadend = function () {
      handlerChanges({
        name: 'image',
        value: [reader.result],
      });
    };
    setFile(event.target.files[0]);
  };

  const getCountries = async () => {
    try {
      const res = await axios.get('/api/address/getAllCountries');
      if (!(res.data.length && res.data.length > 0)) throw new Error('Can\'t get list of countries!');
      setCountries(res.data.map((item) => ({
        label: item.name,
        value: item.isoCode,
      })));
    } catch (error) {
      console.error(error);
    }
  };

  const editProfile = () => {
    setForm({
      ...profile,
      firstName: profile.user.firstName,
      lastName: profile.user.lastName,
      company: profile.company?.name,
    });
    setFile('');
    getCountries();
    changeEditStatus(true);
  };

  const onClose = () => {
    changeEditStatus(false);
    toggleModal(false, 'profile');
  };

  const onActivateAccount = () => {
    toggleModal(true, 'confirmModal', true, { onAccept: onAcceptActivateAccount });
  };

  const onAcceptActivateAccount = async () => {
    toggleModal(false, 'confirmModal', true);
    setLoading(true);
    const { success } = await activateUser();
    if (success) {
      if (auth.user.userType === 'client') {
        getAccountBalanceByClient();
      }
    }
    setLoading(false);
  };

  const onDeactivateAccount = () => {
    setDeactivateModal(true);
    toggleModal(true, 'explanationDeactivationModal', true);
  };

  const getReasonForDeactivateAccount = async (reason) => {
    toggleModal(false, 'explanationDeactivationModal', true);
    setDeactivateModal(false);
    setLoading(true);
    await deactivateUser(reason);
    setLoading(false);
  };

  const approvedBalance = profile.userType === 'contractor' ? (
    <div>
      balance WO:
      {' '}
      {profile.approvedBalance.toLocaleString('en-US', localCurrencySettings)}
    </div>
  ) : null;

  if (!modalStatus.isOpen) return null;

  return (
    <div className="popup_block dashboard-modal dashboard-modal--profile showed">
      <div className="popup_container">
        {isLoading && <DashboardModalLoader />}
        {
          profile
            && (profile.userId === auth.user.id)
            ? (
              <>

                <div className="popup_head dashboard-profile-head">
                  <div className="dashboard-profile-head__main">
                    <div className="popup_title">
                      {profile.company?.name || profile.name}
                    </div>
                    <div className="profile_actions">
                      {profile.status === 'active' && (
                        <>
                          {auth.user.userType === 'contractor' && (
                            <button
                              type="button"
                              className="dashboard-btn dashboard-btn--danger"
                              aria-label="deactivate account"
                              onClick={onDeactivateAccount}
                            >
                              Deactivate Account
                            </button>
                          )}
                          <button
                            type="button"
                            className="dashboard-btn dashboard-btn--secondary"
                            aria-label="edit"
                            onClick={editProfile}
                          >
                            Edit
                          </button>
                        </>
                      )}
                      {profile.status === 'deactivated' && (
                        <button
                          type="button"
                          className="dashboard-btn dashboard-btn--primary"
                          aria-label="activate account"
                          onClick={onActivateAccount}
                        >
                          Activate Account
                        </button>
                      )}
                    </div>
                  </div>
                  <button
                    type="button"
                    className="close_btn"
                    aria-label="close"
                    onClick={onClose}
                  >
                    ×
                  </button>
                </div>

                <div className="popup_body profile_content" ref={contentRef}>
                  {!isEdit ? (
                    // VIEW MODE
                    <div className="view_profile">
                      <div className="profile_main">
                        <div className="info_block">
                          <div className="user_position">{profile.company?.name}</div>
                          <div className="user_name">{profile.name}</div>
                          {profile.date && (
                            <div className="sign_info">
                              Date
                              Registered: {new Date(profile.date).toLocaleDateString('en-US', { timeZone: 'UTC' })}
                            </div>
                          )}
                          {profile.lastLoginAt && (
                            <div className="sign_info">
                              Last
                              Login: {new Date(profile.lastLoginAt).toLocaleString('en-US')}
                            </div>
                          )}
                          {profile.userType === 'contractor' && (
                            <div className="user_name">
                              Rating: {parseInt(profile.currentRating || 100)}%
                            </div>
                          )}
                          {/* Balance Section */}
                          <div className="balance_section user_name">
                            {approvedBalance}
                          </div>
                        </div>
                        <div className="image_block">
                          <img
                            src={profile.image || 'https://www.w3schools.com/css/img_avatar.png'}
                            alt="Avatar"
                          />
                        </div>
                      </div>

                      <ul className="profile_contacts">
                        <li>
                          <div className="profile_label">Address</div>
                          <div className="profile_info">
                            {profile.address !== 'undefined' ? profile.address : ''}
                            {profile.address2 !== 'undefined' && profile.address !== '' ? `, ${profile.address2}` : ''}
                            {(profile.city && profile.city.label) ? `, ${profile.city.label}` : ''}
                            {(profile.state && profile.state.value) ? `, ${profile.state.label}` : ''}
                            {profile.zipcode ? `, ${profile.zipcode}` : ''}
                            {(profile.country && profile.country.value) ? `, ${profile.country.label}` : ''}
                          </div>
                        </li>
                        <li>
                          <div className="profile_label">Website</div>
                          <div className="profile_info">
                            <a href={profile.website !== 'undefined' ? profile.website : ''}
                              target="_blank" rel="noopener noreferrer">
                              {profile.website !== 'undefined' ? profile.website : ''}
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="profile_label">Phone</div>
                          <div className="profile_info">
                            <a href={profile.phone !== 'undefined' ? `tel:${profile.phone}` : ''}>
                              {profile.phone !== 'undefined' ? profile.phone : ''}
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="profile_label">Email</div>
                          <div className="profile_info">
                            <a href={profile.email !== 'undefined' ? `mailto:${profile.email}` : ''}>
                              {profile.email !== 'undefined' ? profile.email : ''}
                            </a>
                          </div>
                        </li>
                      </ul>

                      <div className="about_user">
                        <div className="profile_label">Bio / About:</div>
                        <div
                          className="profile_info"
                          dangerouslySetInnerHTML={{ __html: profile.about !== 'undefined' ? profile.about : '' }}
                        />
                      </div>

                      {profile.userType === 'contractor' && (
                        <div className="about_user">
                          <div className="profile_label">Credentials:</div>
                          <div
                            className="profile_info"
                            dangerouslySetInnerHTML={{ __html: profile.credentials !== 'undefined' ? profile.credentials : '' }}
                          />
                        </div>
                      )}

                      {/* Additional sections */}
                      {profile.userType === 'contractor' && <ButtonControl profile={profile} />}

                      {profile.userType === 'contractor' && profile.certificates?.length ? (
                        <div className="certifications_section">
                          <div className="profile_label">Certifications:</div>
                          <ContractorCertificatesChecks
                            certificates={profile.certificates}
                            infoType="name"
                            size="100%"
                          />
                        </div>
                      ) : null}

                      {profile.userType !== 'contractor' && profile.contractorGroups?.length ? (
                        <div className="preferred_groups">
                          <div className="profile_label">Preferred groups:</div>
                          <div className="groups_list">
                            {profile.contractorGroups.map((group, index) => (
                              <span key={index} className="group_tag">{group}</span>
                            ))}
                          </div>
                        </div>
                      ) : null}

                      {profile.userType !== 'contractor' && (
                        <div className='content'>
                          <NotesSection
                            contractorId={profile.userId}
                            notes={profile.notes}
                          />
                        </div>
                      )}

                      {/* File Upload Section */}
                      {profile.userType === 'contractor' && (
                        <div className="profile-file-upload">
                          <FileUpload values={files} onChange={saveChangedFiles} accept={['image/*', '.pdf']} />
                        </div>
                      )}
                      {profile.userType === 'contractor' && <ContractorToolsWorkTypesDisplay profile={profile} />}
                      {profile.userType === 'contractor' && (
                        <div className="content">
                          <div className="profile_label" style={{ maxWidth: '300px' }}>
                            <div >Other types of work I can do:</div>
                          </div>
                          <div
                            className="profile_info"
                            dangerouslySetInnerHTML={{ __html: profile.other_tools !== 'undefined' ? profile.other_tools : '' }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    // EDIT MODE
                    <div className="form_account">
                      <form onSubmit={handlerSubmit} className="edit_modal">
                        <div className="profile_main">
                          <div className="fields_group">
                            <div className="image_block">
                              <img
                                className="profilepicc"
                                src={form.image || 'https://www.w3schools.com/css/img_avatar.png'}
                                alt="Avatar"
                              />
                            </div>
                            <div className="add_btns">
                              <label className="dashboard-btn dashboard-btn--secondary">
                                <input
                                  type="file"
                                  name="file_attach"
                                  onChange={handleFileUpload}
                                  style={{ display: 'none' }}
                                />
                                Upload image
                              </label>
                              <div className="type_block">jpg or png</div>
                            </div>
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="FirstName">First Name</label>
                          </div>
                          <div className="field_block">
                            <input
                              required
                              type="text"
                              id="FirstName"
                              name="firstName"
                              placeholder="First Name"
                              value={form.firstName || ''}
                              onChange={(event) => handlerChanges(event.target)}
                              maxLength="50"
                            />
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="LastName">Last Name</label>
                          </div>
                          <div className="field_block">
                            <input
                              required
                              type="text"
                              id="LastName"
                              name="lastName"
                              placeholder="Last Name"
                              value={form.lastName || ''}
                              onChange={(event) => handlerChanges(event.target)}
                              maxLength="50"
                            />
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="Phone">Phone</label>
                          </div>
                          <div className="field_block">
                            <input
                              required
                              type="text"
                              id="Phone"
                              name="phone"
                              placeholder="Phone"
                              value={form.phone || ''}
                              onChange={(event) => handlerChanges({
                                name: 'phone',
                                value: normalizePhoneInput(event.target.value, form.phone),
                              })}
                              maxLength="15"
                            />
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="Email">Email</label>
                          </div>
                          <div className="field_block">
                            <input
                              required
                              type="text"
                              id="Email"
                              name="email"
                              placeholder="Email"
                              value={form.email || ''}
                              onChange={(event) => handlerChanges(event.target)}
                              maxLength="50"
                            />
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="Country">Country</label>
                          </div>
                          <div className="field_block">
                            <div className="dashboard-select-wrap">
                              <Select
                                required={profile.userType === 'contractor'}
                                options={countries}
                                styles={dashboardSelectStyle}
                                classNames={dashboardSelectClassNames}
                                onChange={(value) => handlerChanges({
                                  name: 'country',
                                  value,
                                })}
                                value={form.country}
                                inputId="Country"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label
                              htmlFor="State">{form.country?.value === 'CA' ? 'Province' : 'State'}</label>
                          </div>
                          <div className="field_block">
                            <Select
                              required
                              isSearchable
                              options={statesOfCountry}
                              onChange={(value) => handlerChanges({
                                name: 'state',
                                value,
                              })}
                              value={form.state}
                              id="State"
                            />
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="Address">Address</label>
                          </div>
                          <div className="field_block">
                            <input
                              required={profile.userType === 'contractor'}
                              type="text"
                              id="Address"
                              name="address"
                              placeholder="Address"
                              value={form.address || ''}
                              onChange={(event) => handlerChanges(event.target)}
                              maxLength="50"
                            />
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="address2">Suite, Apt., Etc.</label>
                          </div>
                          <div className="field_block">
                            <input
                              type="text"
                              id="address2"
                              name="address2"
                              placeholder="Suite, Apt., Etc."
                              value={form.address2 || ''}
                              onChange={(event) => handlerChanges(event.target)}
                              maxLength="50"
                            />
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="City2">City</label>
                          </div>
                          <div className="field_block">
                            <input
                              required={profile.userType === 'contractor'}
                              type="text"
                              id="City2"
                              name="city"
                              placeholder="City"
                              value={(form.city && form.city.label) || ''}
                              onChange={(event) => handlerChanges({
                                name: 'city',
                                value: {
                                  value: event.target.value,
                                  label: event.target.value,
                                },
                              })}
                              maxLength="50"
                            />
                          </div>
                        </div>

                        <div className="field_row">
                          <div className="field_name">
                            <label htmlFor="Zip2">Zip / Postal Code</label>
                          </div>
                          <div className="field_block">
                            <input
                              required={profile.userType === 'contractor'}
                              type="text"
                              id="Zip2"
                              name="zipcode"
                              placeholder={
                                form.country?.value === 'CA' || form.country?.label === 'Canada'
                                  ? 'A1A 1A1'
                                  : '12345'
                              }
                              value={form.zipcode || ''}
                              onChange={(event) => handlerChanges({
                                name: 'zipcode',
                                value: normalizeZipcodeInput(event.target.value, form.country),
                              })}
                              maxLength={
                                form.country?.value === 'CA' || form.country?.label === 'Canada'
                                  ? 7
                                  : 5
                              }
                            />
                          </div>
                        </div>

                        {profile.userType === 'client' && (
                          <div className="field_row">
                            <div className="field_name">
                              <label htmlFor="CompanyName">Company Name</label>
                            </div>
                            <div className="field_block">
                              <input
                                required
                                type="text"
                                id="CompanyName"
                                name="company"
                                placeholder="Company Name"
                                value={form.company || ''}
                                onChange={(event) => handlerChanges(event.target)}
                                disabled={form.userType === 'user'}
                                maxLength="50"
                              />
                            </div>
                          </div>
                        )}

                        <ProfilePasswordField
                          id="CurrentPassword"
                          name="oldPassword"
                          label="Current Password"
                          value={form.oldPassword}
                          onChange={(event) => handlerChanges(event.target)}
                        />

                        <ProfilePasswordField
                          id="NewPassword"
                          name="password"
                          label="New Password"
                          value={form.password}
                          onChange={(event) => handlerChanges(event.target)}
                        />

                        <ProfilePasswordField
                          id="ConfirmNewPassword"
                          name="confirmPassword"
                          label="Confirm New Password"
                          value={form.confirmPassword}
                          onChange={(event) => handlerChanges(event.target)}
                        />

                        {isEdit && profile.userType === 'contractor' && (
                          <div className="content">
                            <FileUpload values={files} onChange={setFiles}
                              accept={['image/*', '.pdf']} />
                          </div>
                        )}


                        <div className="content">
                          <div className="page_title">
                            <label htmlFor="Bio">Bio / About</label>
                          </div>
                          <div className="field_block">
                            <Editor
                              id="Bio"
                              data={form.about}
                              onChange={(value) => handlerChanges({
                                name: 'about',
                                value: value,
                              })}
                            />
                          </div>
                        </div>

                        <div className="content">
                          {profile.userType === 'contractor' && (
                            <div className="">
                              <div className="page_title">
                                <label htmlFor="Credentials">Credentials</label>
                              </div>
                              <div className="field_block">
                                <Editor
                                  id="Credentials"
                                  data={form.credentials}
                                  onChange={(value) => handlerChanges({
                                    name: 'credentials',
                                    value: value,
                                  })}
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        {profile.userType === 'contractor' && profile.status === 'active' && (
                          <ContractorToolsBox
                            isEdit={isEdit}
                            form={form}
                            handlerChanges={handlerChanges}
                          />
                        )}

                        {profile.userType === 'contractor' && (
                          <div className="content">
                            <div className="page_title">
                              <label htmlFor="OtherWork">Other types of work I can
                                do</label>
                            </div>
                            <div className="field_block">
                              {isEdit ? (
                                <Editor
                                  id="OtherWork"
                                  data={form.other_tools}
                                  onChange={(value) =>
                                    handlerChanges({ name: "other_tools", value })
                                  }
                                />
                              ) : (
                                <div
                                  className="item_text"
                                  dangerouslySetInnerHTML={{ __html: profile.other_tools }}
                                />
                              )}
                            </div>
                          </div>
                        )}

                        <div className="popup_footer">
                          <button
                            type="button"
                            className="dashboard-btn dashboard-btn--secondary"
                            aria-label="cancel"
                            onClick={() => changeEditStatus(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="dashboard-btn dashboard-btn--primary"
                            aria-label="save and publish"
                          >
                            Save & Publish
                          </button>
                        </div>
                      </form>
                    </div>
                  )}
                </div>

                {isDeactivateModal && (
                  <ExplanationDeactivationModal
                    returnExplanation={getReasonForDeactivateAccount}
                    title="Do you really wish to deactivate your account?"
                    isCloseAvailable
                  />
                )}
              </>
            )
            : <Loader />
        }
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  updateProfile,
  toggleModal,
  getProfile,
  getAccountBalanceByClient,
  deactivateUser,
  activateUser,
  getContractorTaxInfo,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  modalStatus: state.modalState.profile,
});

export default connect(
  mapStateToProps, mapDispatchToProps,
)(withRouter(Profile));
